export default __webpack_public_path__ + "img/9b862671a05a214a50be3d456b839b76.png";